// Internationalization Import
import i18n from "i18next";

// Internal Imports
// import { fetchWrapper } from "../../helpers/fetchwrapper";
import { fetchWrapper } from "../helpers/fetchwrapper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { DeleteArrowBackRegular, DeleteRegular } from "@fluentui/react-icons";
// import { baseUrl } from "../../helpers/constants";

// Props
interface IExecuteDialogProps {
  isDialogOpen: boolean;
  title: string;
  subText: string;
  primaryButtonIconName: string;
  primaryButtonText: string;
  executeUrl: string;
  onDismiss: any;
  onExecute: any;
  onError: any;
}

// Function
function ExecuteDialog(props: IExecuteDialogProps) {
  const execute = () => {
    fetchWrapper
      .get(`${props.executeUrl}`)
      .then((data: any) => {
        props.onExecute(data);
      })
      .catch(() => {
        props.onError();
      });
  };

  return (
    <div>
      <Dialog open={props.isDialogOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{props.primaryButtonText}</DialogTitle>
            <DialogContent>{props.title}</DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                icon={
                  props.primaryButtonIconName == "Delete" ? (
                    <DeleteRegular />
                  ) : (
                    <DeleteArrowBackRegular />
                  )
                }
                onClick={() => execute()}
              >
                {props.primaryButtonText}
              </Button>
              <Button onClick={() => props.onDismiss()}>
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
      {/* <Dialog
        hidden={!}
        onDismiss={() => props.onDismiss()}
        dialogContentProps={deleteDialogContentProps}
        modalProps={modalProps}
      >
        <DialogFooter>
          <PrimaryButton
            iconProps={{ iconName: props.primaryButtonIconName }}
            
            text=
          />
          <DefaultButton
            iconProps={{ iconName: "Cancel" }}
            
            text=
          />
        </DialogFooter>
      </Dialog> */}
    </div>
  );
}

// Export Function
export default ExecuteDialog;
